import React, { useEffect, useState } from "react";
import NavBar from "./NavBar";
import { Outlet, useLocation } from "react-router-dom";
import HeadRibbon from "./HeadRibbon";
import Footer from "./Footer";

export default function Layout() {
  const { pathname } = useLocation();

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);

  return (
    <div className="min-h-screen bg-lime-900/5 bg-opacity-10 font-traffic text-green-950">
      <HeadRibbon />

      <NavBar />

      <main className="min-h-screen">
        <Outlet />
      </main>

      <Footer />
    </div>
  );
}
